import type {NodeProvidedProps} from '@visx/network/lib/types';
import type {FC} from 'react';
import React from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ChannelIcon, ChannelIconSizesEnum} from '../../../../components/common/channelIcon';
import type {InboxGraphChannelNode} from '../inboxGraphTypes';
import {getNodeHeight} from '../inboxGraphUtils';
import {RectangleNodeComponent} from './rectangleNodeComponent';

const StyledLabel = styled.div`
  padding: 0 12px;
  width: 100%;
  margin-top: 8px;
  text-align: center;
  line-height: 18px;
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  ${ellipsis()}
`;

const StyledImg = styled(ChannelIcon)`
  height: 32px;
  width: 32px;
`;

/**
 * Returns a node representing a channel in an inbox graph.
 */
export const ChannelNodeComponent: FC<NodeProvidedProps<InboxGraphChannelNode>> = ({node}) => {
  const nodeHeight = getNodeHeight(node);
  const theme = useUserTheme();

  return (
    <RectangleNodeComponent
      height={nodeHeight}
      defaultFill={theme.greys.shade30}
      hoveredFill={theme.greys.shade40}
      onClick={node.onClick}
      tooltipContent={node.label}
    >
      <StyledImg type={node.uniqueChannelType} size={ChannelIconSizesEnum.BIG} />
      <StyledLabel>{node.label}</StyledLabel>
    </RectangleNodeComponent>
  );
};
